import { Dispatch } from 'redux';
import { RootState } from 'store/configureStore';
import { fetchFirmDetails } from 'utils/api/firms';
import { setFirm, setIsLoading } from 'screens/Panel/screens/Firm/store/show/actions';

const loadFirm = (firmId: string) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(setIsLoading(true));
    try {
      const details = await fetchFirmDetails(firmId);
      dispatch(setFirm(details));
    } catch (e) {
      throw e;
    }
    dispatch(setIsLoading(false));
  };
};

export default loadFirm;
